module.exports = __webpack_public_path__ + "46ceddef9c9de057fddd7350fe160797.svg";